import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Homepage from "./pages/homepage/Homepage";
import Account from "./pages/account/Account";
import Products from "./pages/products/Products";
import Product from "./pages/product/Product";
// import HelpCenter from "./pages/help-center/HelpCenter";
// import Policies from "./pages/policies/Policies";
// import Guide from "./pages/guide/Guide";
// import NotFound from "./pages/not-found/NotFound";
import Contact from "./pages/contact/Contact";
import { StyledApp } from "./styled/StyledApp";
import ScrollToTop from "./hooks/ScrollToTop";
import Brand from "./pages/brand/Brand";
import Brands from "./pages/brands/Brands";
import Configuration from "./Configuration";
// import MyWearables from "./pages/dashboard/wearables/MyWearables";
import ManOfTheMatch from "./pages/man-of-the-match/ManOfTheMatch";
import ManOfTheMatchSubmitted from "./pages/man-of-the-match-submitted/ManOfTheMatchSubmitted";
import BusinessCardMocked from "./pages/business-card-mocked/BusinessCardMocked";
import BusinessCard from "./pages/business-card/BusinessCard";
import AscotFamilyDay from "./pages/ascot-family-day/AscotFamilyDay";
import Registration from "./pages/ascot-family-day/Registration";
import Location from "./pages/ascot-family-day/Location";
import Feedback from "./pages/ascot-family-day/Feedback";
import Progress from "./pages/ascot-family-day/Progress";
import CagedSteelPromo from "./pages/caged-steel-promo/CagedSteelPromo";
import FeedbackForm from "./pages/caged-steel-promo/FeedbackForm";
import CampaignManager from "./pages/campaign-manager/CampaignManager";
import EventManager from "./pages/event-manager/EventManager";
import DevicesManager from "./pages/campaign-manager/DevicesManager";
import SearchDevices from "./pages/campaign-manager/SearchDevices";
import Campaign from "./pages/campaign-manager/Campaign";
import CampaignLinks from "./pages/campaign-manager/components/CampaignLinks";
import VotingResults from "./pages/campaign-manager/VotingResults";
import ScavengerHunt from "./pages/campaign-manager/ScavengerHunt";
import CoachTrackerCampaign from "./pages/campaign-manager/CoachTrackerCampaign";
import ScavengerDeliverPrizes from "./pages/campaign-manager/ScavengerDeliverPrizes";
import BalanceAndPin from "./pages/balance-and-pin/BalanceAndPin";
import { AscotFontStyle } from "./pages/ascot-family-day/styled/SharedStyles";
import { MuchBetterFontStyle } from "./pages/balance-and-pin-mb-christmas/styled/BalanceAndPinMuchBetterChristmasStyles";
import BalanceAndPinMuchBetterChristmas from "./pages/balance-and-pin-mb-christmas/BalanceAndPinMuchBetterChristmas";
import MasterCardDemo from "./pages/mastercard-demo/MasterCardDemo";
import ElectricalSafety from "./pages/electrical-safety/ElectricalSafety";
import CreateCampaign from "./pages/campaign-manager/CreateCampaign";
import EditCampaign from "./pages/campaign-manager/EditCampaign";
import CampaignDevices from "./pages/campaign-manager/CampaignDevices";
import PromoReadyAdmin from "./pages/campaign-manager/PromoReadyAdmin";
import TransferDevices from "./pages/campaign-manager/TransferDevices";
import CreateDevice from "./pages/campaign-manager/CreateDevice";
import EditDevice from "./pages/campaign-manager/EditDevice";
import DeviceLinks from "./pages/campaign-manager/components/DeviceLinks";
import LeoSchachter from "./pages/leo-schachter/LeoSchachter";
import Event from "./pages/event-manager/Event";
import RolandGarros from "./pages/roland-garros/RolandGarros";
import UefaPromoReady from "./pages/uefa/UefaPromoReady";
import UefaPitchesOfHope from "./pages/uefa/UefaPitchesOfHope";
import ScsPromoReady from "./pages/scs-promo-ready/ScsPromoReady";
import SodexoPromoReady from "./pages/sodexo-promo-ready/SodexoPromoReady";
import FossilProductInformation from "./pages/fosil-promo-ready/FossilProductInformation";
import FossilVote from "./pages/fosil-promo-ready/FossilVote";
import BelfastPromoReady from "./pages/belfast-giants-promo/BelfastGiantsPromo";
import HugoBoss from "./promo-ready/hugo-boss/HugoBoss";
import Tap2Start from "./promo-ready/tap2start/Tap2Start";
// import Tap2StartTap2 from "./promo-ready/tap2start-tap2/Tap2StartTap2";
import Tap2StartSmartex from "./promo-ready/tap2start-smartex/Tap2StartSmartex";
import Tap2StartScs from "./promo-ready/tap2start-scs/Tap2StartScs";
import { Tap2FontStyle } from "./promo-ready/tap2start-tap2/styles/SharedStyles";
import RugbyWcCapgemini from "./promo-ready/rugby-wc-capgemeni/RugbyWcCapgemini";
import RugbyWcAsahi from "./promo-ready/rugby-wc-asahi/RugbyWcAsahi";
import RugbyWcLandRover from "./promo-ready/rugby-wc-landrover/RugbyWcLandRover";
import ChesterRacecourse from "./promo-ready/chester-racecourse/ChesterRacecourse";
import AfterEvent from "./pages/caged-steel-promo/AfterEvent";
import Infineon from "./promo-ready/infineon/Infineon";
import HugoBossExperience from "./promo-ready/hugo-boss-experience/HugoBossExperience";
import BluewaterPromoReady from "./promo-ready/bluewater/Bluewater";
import LostModePage from "./promo-ready/lost-mode/LostModePage";
import IceMuchbetter from "./promo-ready/ice-muchbetter/IceMuchbetter";

import Planica24 from "./promo-ready/planica24/Planica24";
import Road2Milan from "./promo-ready/road2milan/Road2Milan";
import Freemans from "./promo-ready/freemans/Freemans";
import Pepcity from "./promo-ready/pepcity/Pepcity";
import { PepsicoFontStyle } from "./promo-ready/pepcity/styles/Pepcity";
import Uefa24 from "./promo-ready/uefa24/Uefa24";
import { MasterCardDemoFonts } from "./pages/mastercard-demo/styles/MasterCardDemoStyles";
import RolandGarros24 from "./promo-ready/roland-garros24/RolandGarros24";
import CoachTrackerLogin from "./pages/coach-tracker-login/CoachTrackerLogin";
import GuestTrackerLogin from "./pages/guests-tracker-login/GuestsTrackerLogin";
import CoachTracker from "./pages/coach-tracker/CoachTracker";
import InfoCollectorAdmin from "./pages/info-collector-admin/InfoCollectorAdmin";
import RolandGarros26 from "./promo-ready/rg25/RolandGarros26";
import Money2020 from "./promo-ready/money-2020/Money2020";
import TasteOfDublin from "./promo-ready/taste-of-dublin/TasteOfDublin";
import TasteOfDublin25 from "./promo-ready/taste-of-dublin/TasteOfDublin25";
import CocaCola2024 from "./promo-ready/coca-cola-2024/CocaCola2024";
import { CocaColaFontStyle } from "./promo-ready/coca-cola-2024/styles";
import TourDeFrance from "./promo-ready/tour-de-france-24/TourDeFrance";
import BritishGas from "./promo-ready/british-gas-24/BritishGas";
import { BritishGasFontStyle } from "./promo-ready/british-gas-24/styles/BritishGas";
import CampBestival24 from "./promo-ready/camp-bestival-24/CampBestival24";
import Callback3ds from "./promo-ready/callback-3ds/Callback3ds";
import ArosaClassicCar from "./promo-ready/arosa-classic-car/ArosaClassicCar";
import TencoBobo from "./promo-ready/tenco-bobo/TencoBobo";
import Tap2Promo from "./promo-ready/tap2-promo/Tap2Promo";
import Faqs from "./pages/faqs/Faqs";
import FaqTopic from "./pages/faqs/FaqTopic";
import FaqSubTopic from "./pages/faqs/FaqSubTopic";
import FaqQuestion from "./pages/faqs/FaqQuestion";
import OpenBankingYaspa from "./promo-ready/open-banking-yaspa/OpenBankingYaspa";
import Worlds24 from "./promo-ready/worlds24/Worlds24";
import Greece24 from "./promo-ready/greece24/Greece24";
import Ekko from "./promo-ready/ekko/Ekko";
import EkkoDemo from "./promo-ready/ekko-demo/EkkoDemo";
import MBPaymentAccount from "./promo-ready/mb-payment-account/MBPaymentAccount";
import McLear from "./promo-ready/mclear/McLear";
import Singapore24 from "./promo-ready/singapore24/Singapore24";
import ChristmasWizard24 from "./promo-ready/christmas-wizard-24/ChristmasWizard24";
import TwoFactorAuthCode from "./pages/2fa-auth-code/TwoFactorAuthCode";
import Electronica24 from "./promo-ready/electronica24/Electronica24";
import Vietnam24 from "./promo-ready/vietnam24/Vietnam24";
import Megeve25 from "./promo-ready/megeve25/Megeve25";
import Kitzbuhel25 from "./promo-ready/kitzbuhel-25/Kitzbuhel25";
import Haptics25 from "./promo-ready/haptics25/Haptics25";
import Ao25 from "./promo-ready/ao25/Ao25";
import RecipeHarvest from "./promo-ready/recipe-harvest/RecipeHarvest";
import Pay36025 from "./promo-ready/pay360-25/Pay360";
import Ldbx from "./promo-ready/ldbx/Ldbx";
import { VeloFontStyle } from "./promo-ready/velo/styles";
import Velo from "./promo-ready/velo/Velo";
import Electronica25 from "./promo-ready/electronica25/Electronica25";
import Cannes25 from "./promo-ready/cannes-f1-25/Cannes25";
import Cannes26 from "./promo-ready/cannes-f1-25/Cannes26";
import F125 from "./promo-ready/cannes-f1-25/F125";
import RolandGarros25 from "./promo-ready/rg25/RolandGarros25";
import {
  SchneidlerLateinMediumFont,
  SchneidlerLateinRegularFont
} from "./promo-ready/pepcity25/styles";
import Pepcity25 from "./promo-ready/pepcity25/Pepcity25";
import Uefa26Pepcity from "./promo-ready/uefa26-pepcity/Uefa26Pepcity";
import CurveAccount from "./promo-ready/curve-account/CurveAccount";
import JLR2025 from "./promo-ready/jlr2025/JLR2025";
import {
  JLREmericWebExtraLightFont,
  JLREmericExtraLightFont,
  JLREmericRegularFont,
  JLREmericSemiBoldFont
} from "./promo-ready/jlr2025/styles";
import Playstation25 from "./promo-ready/playstation25/Playstation25";
import Playstation26 from "./promo-ready/playstation26/Playstation26";
import Topps25 from "./promo-ready/topps25/Topps25";
import Topps26 from "./promo-ready/topps25/Topps26";
import { ChampionsWebRegularFont, CountachBoldFont, SinterRegularFont } from "./promo-ready/topps25/styles";
import Oktobertech25 from "./promo-ready/oktobertech25/Octobertech25";
import AustrianGp25 from "./promo-ready/austrian-gp-25/AustrianGp25";
import JapanTirol from "./promo-ready/japan-tirol/JapanTirol";
import {
  PPEikoLightFont,
  PPEikoLightItalicFont,
  PPEikoRegularFont
} from "./promo-ready/japan-tirol/styles";
import RugbyWc25 from "./promo-ready/rugbywc25/RugbyWc25";
import GuestTracker from "./pages/guest-tracker/GuestTracker";
import CheckedInUsers from "./pages/mdes-event/CheckedInUsers";
import CheckedInGuestsWall from "./pages/mdes-event/CheckedInUsersWall";
import LiveNation25 from "./promo-ready/live-nation-25/LiveNation25";
import SailGp25 from "./promo-ready/sail-gp-25/SailGp25";
import Trustech25 from "./promo-ready/trustech25/Trustech25";
import Trustech25Dld from "./promo-ready/trustech25/Trustech25Dld";
import Kitzbuhel26 from "./promo-ready/kitzbuhel-25/Kitzbuhel26";
import Hsbc26 from "./promo-ready/hsbc-26/Hsbc26";
import Priceless26 from "./promo-ready/priceless-26/Priceless26";
import BritishGas26 from "./promo-ready/british-gas-24/BritishGas26";
import Callback3dsVisa from "./promo-ready/callback-3ds-visa/Callback3ds";
import Planica26 from "./promo-ready/planica26/Planica26";
import WidgetsDemo from "./promo-ready/widgets-demo/WidgetsDemo";
import MuchBetterReferralDemo from "./promo-ready/much-better-referral-demo/MuchBetterReferralDemo";
import Uefa26Lidl from "./promo-ready/uefa26-lidl/Uefa26Lidl";
import {
  LidlFontCondProBoldFont,
  LidlFontCondProRegularFont,
  LidlFontProBoldFont,
  LidlFontProBookFont
} from "./promo-ready/uefa26-lidl/styles";
import Uefa26Hospitality from "./promo-ready/uefa26-hospitality/Uefa26Hospitality";

function App() {
  return (
    <>
      <Router>
        <Configuration />
        <ScrollToTop />
        <PPEikoLightFont />
        <PPEikoRegularFont />
        <PPEikoLightItalicFont />
        <AscotFontStyle />
        <MuchBetterFontStyle />
        <MasterCardDemoFonts />
        <Tap2FontStyle />
        <PepsicoFontStyle />
        <BritishGasFontStyle />
        <CocaColaFontStyle />
        <VeloFontStyle />
        <ChampionsWebRegularFont />
        <CountachBoldFont />
        <SinterRegularFont />
        <SchneidlerLateinMediumFont />
        <SchneidlerLateinRegularFont />
        <JLREmericWebExtraLightFont />
        <JLREmericExtraLightFont />
        <JLREmericRegularFont />
        <JLREmericSemiBoldFont />
        <ChampionsWebRegularFont />
        <LidlFontProBookFont />
        <LidlFontProBoldFont />
        <LidlFontCondProRegularFont />
        <LidlFontCondProBoldFont />
        <StyledApp>
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/products" element={<Products />} />
            <Route
              path="/products/:brand/:model/:version"
              element={<Product />}
            />
            <Route path="/brands" element={<Brands />} />
            <Route path="/brands/:brand" element={<Brand />} />
            {/* <Route path="/help" element={<HelpCenter />} /> */}
            <Route path="/contact" element={<Contact />} />
            <Route path="/account" element={<Account />} />
            <Route path="coach-tracker-login" element={<CoachTrackerLogin />} />
            <Route path="coach-tracker" element={<CoachTracker />} />
            <Route
              path="info-collector/:eventId"
              element={<InfoCollectorAdmin />}
            />
            <Route path="guest-tracker-login" element={<GuestTrackerLogin />} />
            <Route path="guest-tracker" element={<GuestTracker />} />

            {/* <Route path="/policies" element={<Policies />} />z
            <Route path="/guide" element={<Guide />} /> */}
            {/* <Route path="/wearables" element={<MyWearables />} /> */}
            <Route path="/business-card/:id" element={<BusinessCardMocked />} />
            <Route path="/business-card/" element={<BusinessCard />} />
            <Route path="/campaign-manager" element={<CampaignManager />} />
            <Route path="/event-manager" element={<EventManager />} />
            <Route path="/devices-manager" element={<DevicesManager />} />
            <Route path="/devices-manager/search" element={<SearchDevices />} />
            <Route path="/devices-manager/create" element={<CreateDevice />} />
            <Route
              path="/devices-manager/:serial/edit"
              element={<EditDevice />}
            />
            <Route
              path="/devices-manager/:serial/links"
              element={<DeviceLinks />}
            />
            <Route path="/das-admin" element={<PromoReadyAdmin />} />
            <Route
              path="/campaign-manager/new-campaign"
              element={<CreateCampaign />}
            />
            <Route
              path="/campaign-manager/:campaignId/edit"
              element={<EditCampaign />}
            />
            <Route
              path="/campaign-manager/:campaignId/transfer"
              element={<TransferDevices />}
            />
            <Route
              path="/campaign-manager/:campaignId/links"
              element={<CampaignLinks />}
            />
            <Route
              path="/campaign-manager/:campaignId/devices"
              element={<CampaignDevices />}
            />
            <Route
              path="/campaign-manager/:campaignId/voting-results"
              element={<VotingResults />}
            />
            <Route
              path="/campaign-manager/:campaignId/scavenger-hunt"
              element={<ScavengerHunt />}
            />
            <Route
              path="/campaign-manager/:campaignId/coach-tracker"
              element={<CoachTrackerCampaign />}
            />
            <Route
              path="/campaign-manager/:campaignId/scavenger-hunt/deliver-prizes"
              element={<ScavengerDeliverPrizes />}
            />
            <Route
              path="/campaign-manager/:campaignId"
              element={<Campaign />}
            />
            <Route path="/event-manager/:eventId" element={<Event />} />
            <Route path="/caged-steel-promo/" element={<CagedSteelPromo />} />
            <Route path="/roland-garros/" element={<RolandGarros />} />
            <Route path="/rg24/" element={<RolandGarros24 />} />
            <Route path="/rg26/" element={<RolandGarros26 />} />
            <Route path="/uefa/" element={<UefaPromoReady />} />
            <Route path="/uefa24/" element={<Uefa24 />} />
            <Route
              path="/uefa-pitches-of-hope/"
              element={<UefaPitchesOfHope />}
            />
            <Route path="/scs/" element={<ScsPromoReady />} />
            <Route path="/sodexo/" element={<SodexoPromoReady />} />
            <Route
              path="/caged-steel-promo/:serial/feedback"
              element={<FeedbackForm />}
            />
            <Route
              path="/ascot-family-day/:serial"
              element={<AscotFamilyDay />}
            />
            <Route
              path="/ascot-family-day/:serial/registration"
              element={<Registration />}
            />
            <Route
              path="/ascot-family-day/:serial/:location"
              element={<Location />}
            />
            <Route
              path="/ascot-family-day/:serial/feedback"
              element={<Feedback />}
            />
            <Route
              path="/ascot-family-day/:serial/progress"
              element={<Progress />}
            />

            <Route
              path="/real-betis-vs-celta-vigo-mom"
              element={<ManOfTheMatch />}
            />
            <Route
              path="/nomination-submitted"
              element={<ManOfTheMatchSubmitted />}
            />
            <Route
              path="/anonymous-prepaid-balance-and-pin"
              element={<BalanceAndPin />}
            />
            <Route path="/digiseq-happy-holidays" element={<BalanceAndPin />} />
            <Route
              path="/much-better-happy-holidays"
              element={<BalanceAndPinMuchBetterChristmas />}
            />
            <Route path="/mastercard" element={<MasterCardDemo />} />
            <Route path="/electrical-safety" element={<ElectricalSafety />} />
            <Route path="/leo-schachter" element={<LeoSchachter />} />
            <Route
              path="/fossil-promo-ready/product/"
              element={<FossilProductInformation />}
            />
            <Route path="/fossil-promo-ready/vote/" element={<FossilVote />} />
            <Route path="/belfast-giants" element={<BelfastPromoReady />} />
            <Route path="/hugo-boss-promo-ready" element={<HugoBoss />} />
            <Route path="/tap2start" element={<Tap2Start />} />
            <Route path="/tap2start/tap2" element={<Tap2Promo />} />
            <Route path="/tap2start/smartex" element={<Tap2StartSmartex />} />
            <Route path="/tap2start/scs" element={<Tap2StartScs />} />
            <Route path="/rugbywc-capgemini" element={<RugbyWcCapgemini />} />
            <Route path="/rugbywc-asahi" element={<RugbyWcAsahi />} />
            <Route path="/rugbywc-landrover" element={<RugbyWcLandRover />} />
            <Route path="/chester-racecourse" element={<ChesterRacecourse />} />
            <Route path="/cs-after-event" element={<AfterEvent />} />
            <Route path="/infineon-promo" element={<Infineon />} />
            <Route
              path="/hugo-boss-experience"
              element={<HugoBossExperience />}
            />
            <Route path="/lost-mode" element={<LostModePage />} />
            <Route path="/ice-muchbetter" element={<IceMuchbetter />} />
            <Route path="/bluewater" element={<BluewaterPromoReady />} />
            <Route path="/pay360" element={<Pay36025 />} />
            <Route path="/planica24" element={<Planica24 />} />
            <Route path="/road2milan" element={<Road2Milan />} />
            <Route path="/freemans" element={<Freemans />} />
            <Route path="/pepcity" element={<Pepcity />} />
            <Route path="/money-2020" element={<Money2020 />} />
            <Route path="/taste-of-dublin" element={<TasteOfDublin />} />
            <Route path="/taste-of-dublin-25" element={<TasteOfDublin25 />} />
            <Route path="/coca-cola-2024" element={<CocaCola2024 />} />
            <Route path="/tour-de-france-24" element={<TourDeFrance />} />
            <Route path="/british-gas-24" element={<BritishGas />} />
            <Route path="/camp-bestival-24" element={<CampBestival24 />} />
            <Route path="/3ds-callback" element={<Callback3ds />} />
            <Route
              path="/3ds/3dsActivationResult"
              element={<Callback3dsVisa />}
            />

            <Route path="/arosa-classic-car" element={<ArosaClassicCar />} />
            <Route path="/tenco-bobo" element={<TencoBobo />} />
            <Route path="/tap2promo" element={<Tap2Promo />} />
            <Route path="/faqs" element={<Faqs />} />
            <Route path="/faqs/:topic" element={<FaqTopic />} />
            <Route path="/faqs/:topic/:subTopic" element={<FaqSubTopic />} />
            <Route
              path="/faqs/:topic/:subTopic/:index"
              element={<FaqQuestion />}
            />
            <Route path="/open-banking-yaspa" element={<OpenBankingYaspa />} />
            <Route path="/worlds24" element={<Worlds24 />} />
            <Route path="/greece24" element={<Greece24 />} />
            <Route path="/ekko" element={<Ekko />} />
            <Route path="/ekko-demo" element={<EkkoDemo />} />
            <Route path="/mb-payment-account" element={<MBPaymentAccount />} />
            <Route path="/mclear" element={<McLear />} />
            <Route path="/singapore24" element={<Singapore24 />} />
            <Route
              path="/christmas-wizard-24"
              element={<ChristmasWizard24 />}
            />
            <Route path="/2fa-auth-code" element={<TwoFactorAuthCode />} />
            <Route path="/electronica24" element={<Electronica24 />} />
            <Route path="/vietnam24" element={<Vietnam24 />} />
            <Route path="megeve25" element={<Megeve25 />} />
            <Route path="/kitzbuhel25" element={<Kitzbuhel25 />} />
            <Route path="/kitzbuhel26" element={<Kitzbuhel26 />} />
            <Route path="/ao25" element={<Ao25 />} />
            <Route path="/haptics25" element={<Haptics25 />} />
            <Route path="/recipe-harvest" element={<RecipeHarvest />} />
            <Route path="/ldbx" element={<Ldbx />} />
            <Route path="/velo" element={<Velo />} />
            <Route path="/electronica25" element={<Electronica25 />} />
            <Route path="/cannes25" element={<Cannes25 />} />
            <Route path="/cannes26" element={<Cannes26 />} />
            <Route path="/f125" element={<F125 />} />
            <Route path="/rg25" element={<RolandGarros25 />} />
            <Route path="/pepcity25" element={<Pepcity25 />} />
            <Route path="/uefa26-pepcity" element={<Uefa26Pepcity />} />
            <Route path="/curve-account" element={<CurveAccount />} />
            <Route path="/jlr2025" element={<JLR2025 />} />
            <Route path="/playstation25" element={<Playstation25 />} />
            <Route path="/playstation26" element={<Playstation26 />} />
            <Route path="/topps25" element={<Topps25 />} />
            <Route path="/topps26" element={<Topps26 />} />
            <Route path="/oktobertech25" element={<Oktobertech25 />} />
            <Route path="/austrian-gp25" element={<AustrianGp25 />} />
            <Route path="/japan-tirol" element={<JapanTirol />} />
            <Route path="/rugbywc25" element={<RugbyWc25 />} />
            <Route path="/mdes-event-25" element={<CheckedInUsers />} />
            <Route
              path="/mdes-event-25/wall"
              element={<CheckedInGuestsWall />}
            />
            <Route path="/live-nation-25" element={<LiveNation25 />} />
            <Route path="/sail-gp-25" element={<SailGp25 />} />
            <Route path="/trustech25" element={<Trustech25 />} />
            <Route path="/trustech25-dld" element={<Trustech25Dld />} />
            <Route path="/hsbc-26" element={<Hsbc26 />} />
            <Route path="/priceless26" element={<Priceless26 />} />
            <Route path="/british-gas-26" element={<BritishGas26 />} />
            <Route path="/planica26" element={<Planica26 />} />
            <Route path="/uefa26-lidl" element={<Uefa26Lidl />} />
            <Route path="/uefa26-hospitality" element={<Uefa26Hospitality />} />
            <Route path="/widgets-demo/preferences" element={<WidgetsDemo />} />
            <Route path="/widgets-demo" element={<WidgetsDemo />} />
            <Route path="/widgets-demo/:view" element={<WidgetsDemo />} />
            <Route
              path="/much-better-referral"
              element={<MuchBetterReferralDemo />}
            />

            <Route path="*" element={<Homepage />} />
          </Routes>
        </StyledApp>
      </Router>
    </>
  );
}

export default App;
